import React from "react";
import { Box } from "@mui/material";

import { IconPanelProps } from "./IconPanel.types";
import { useStyles } from "./IconPanel.styles";

function IconPanel(props: IconPanelProps) {
  const { children, icon, color, hasBorderRadius, ...other } = props;

  const classes = useStyles(props);

  return (
    <Box className={classes.root} {...other}>
      <div className={classes.icon}>{icon}</div>
      <div className={classes.content}>{children}</div>
    </Box>
  );
}

export default IconPanel;
